import React, { useState, useEffect, useMemo } from "react";
import { Typography, Grid, Select, MenuItem, Button, InputLabel } from '@mui/material';
import { Container } from "@mui/system";
import { useSearchParams } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import BlogPostCard from "../../components/BlogPostCard/BlogPostCard";
import { publicApi } from "../../api/http";


function BlogPosts() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [blogPosts, setBlogPosts] = useState(null);
    const [authors, setAuthors] = useState([]);
    const [author, setAuthor] = useState(searchParams.get('author_id') || "");
    const [error, setError] = useState(null);

    useEffect(() => {
        publicApi.get("/blog_posts", { params: { "author_id": author } }).then((response) => {
            setBlogPosts(response.data);
        })
            .catch((error) => {
                setError(error);
            });

    }, [author]);

    useEffect(() => {
        setAuthor(searchParams.get('author_id') || "");
    }, [searchParams]);

    useEffect(() => {
        publicApi.get("/authors").then((response) => {
            setAuthors(response.data);
        })
            .catch((error) => {
                setError(error);
            });
    }, []);

    const sortedAuthors = useMemo(
        () => [...authors].sort((a, b) => a.author_name.localeCompare(b.author_name)),
        [authors]
    );

    const handleAuthorChange = (event) => {
        const nextAuthor = event.target.value;
        setAuthor(nextAuthor);
        setSearchParams(nextAuthor ? { author_id: nextAuthor } : {});
    };

    const clearFilters = () => {
        setAuthor("");
        setSearchParams();
    };

    return (
        <>
            <Helmet>
                <title>Blog Posts - Hockey Pipeline</title>
                <meta name="description" content="Read NHL prospect analysis, draft insights, and hockey scouting articles from Hockey Pipeline writers." />
                <link rel="canonical" href="https://hockeypipeline.com/blog" />
            </Helmet>
            <Container Container className="container top-container">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12}>
                    <Typography variant="h4" component="div" className="page-title">
                        Blog Posts
                    </Typography>
                    <div className="title-underline" />
                    <Grid container spacing={2} justifyContent="right">
                        <Grid item xs={12} sm={6} md={3} justify="center" alignItems="center" direction="row" >
                            <InputLabel className="drop-down-label">Author</InputLabel>
                            <Select
                                value={author}
                                autoWidth
                                label="Author"
                                labelId="demo-simple-select-autowidth-label"
                                id="demo-simple-select-autowidth"
                                className="drop-down"
                                onChange={handleAuthorChange}
                                size="small"
                            >
                                <MenuItem value="">All Authors</MenuItem>
                                {sortedAuthors.map((author) => (
                                    <MenuItem key={author.author_id} value={author.author_id}>
                                        {author.author_name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Grid>
                        <Grid item xs={12} sm={3} md={2} className="clear-btn-container" >
                            <Button
                                variant="outlined"
                                className="clear-btn"
                                onClick={clearFilters}
                            >
                                Clear Filter
                            </Button>
                        </Grid>
                    </Grid>
                    {blogPosts && blogPosts.map((blogPost) => (
                        <Grid item xs={12} sm={12} md={12}>
                            <BlogPostCard blogPost={blogPost} />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </Container>
        </>
    );
};

export default BlogPosts;